import { useEffect, useRef } from 'react';
import { ADSENSE_CLIENT, isLocalHost } from '../utils/ads';

function AdUnit({ slot, format = 'auto' }) {
  const pushed = useRef(false);

  useEffect(() => {
    if (isLocalHost() || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch {
      // AdSense may throw if the loader is blocked or the slot is a placeholder.
    }
  }, [slot]);

  if (isLocalHost()) {
    return (
      <div
        className="flex items-center justify-center min-h-[90px] rounded-lg border border-dashed border-purple-300 bg-purple-50 text-sm text-purple-700 dark:border-purple-700 dark:bg-gray-800 dark:text-purple-300"
        aria-hidden="true"
      >
        Ad placeholder ({slot})
      </div>
    );
  }

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    />
  );
}

export default AdUnit;
